<template>
    <div class="result-dashboard">
        <div :key="key" v-for="(item, key) in listPreGoalDefault" class="card card-target p-3 mb-2 d-flex flex-column justify-content-between" >
            <div class="d-flex justify-content-end align-items-center">
                <el-tooltip :content="'Mục tiêu ' + dateByKey[item]?.tooltip" placement="top">
                    <span class="text-muted"><i class="el-icon-question text-info mr-1"></i>{{ `${listPreGoal[item] ? "Mục tiêu " : item === 'pre_day' ? 'Kết quả' : "Mục tiêu"} ${dateByKey[item]?.date ?? ''}`  }}</span>
                </el-tooltip>
                <el-tooltip content="Sửa" placement="top">
                    <i v-if="listPreGoal[item]"
                       @click="handleShowDialogTarget(listPreGoal[item], item, dateByKey[item]?.goal_type)"
                       class="ml-2 el-icon-edit-outline cursor-pointer"
                    ></i>
                </el-tooltip>
                <el-tooltip :disabled="loadingRestore" content="đồng bộ kết quả" placement="top">
                    <i v-if="listPreGoal[item] && !loadingRestore"
                       @click="synchronizeGoal(listPreGoal[item], dateByKey[item]?.goal_type)"
                       class="ml-2 el-icon-eleme cursor-pointer"
                    ></i>
                  <i :class="loadingRestore ? 'el-icon-loading' : ''" class="ml-1"></i>
                </el-tooltip>

                <el-tooltip :disabled="loadingRestore" :content="'Nhập ' + dateByKey[item]?.title" placement="top">
                    <i v-if="listPreGoal[item] && !loadingRestore"
                       @click="showDialogTarget(item, dateByKey[item]?.goal_type)"
                       class="ml-2 el-icon-s-promotion cursor-pointer"
                    ></i>
                    <i :class="loadingRestore ? 'el-icon-loading' : ''" class="ml-1"></i>
                </el-tooltip>
            </div>
            <div v-if="listPreGoal[item] == null">
                <div class="text-center  mt-3" style="margin-bottom: 22px">
                    <i v-if="item !== 'pre_day'"
                       @click="handleShowDialogTarget(listPreGoal[item], item, dateByKey[item]?.goal_type)"
                        class="cursor-pointer el-icon-plus text-white p-2 mt-4 mb-4 rounded-circle"
                        style="background-color: #472f92; font-size: 35px"
                    ></i>
                </div>
                <div class="text-center" :class="{'mt-4 mb-4': item === 'pre_day' }">
                    <p class="target-title  m-0">{{item === 'pre_day' ? `Bạn chưa nhập mục tiêu ngày ${dateByKey[item]?.date ?? ''}` : `Nhập ${dateByKey[item]?.title ?? ''}`}}</p>
                </div>
            </div>
            <div  v-else class="mt-2">
                <p class="target-title mb-1"> <span
                    :class="{'text-danger': listPreGoal[item]?.customer_new < listPreGoal[item]?.target_customer_new , 'text-success': listPreGoal[item]?.customer_new >= listPreGoal[item]?.target_customer_new}">
                    {{ listPreGoal[item]?.customer_new | formatVNDNoPrefix}}</span>
                    /
                    <span>{{ listPreGoal[item]?.target_customer_new | formatVNDNoPrefix}} </span>
                    <small>KH mới</small>
                </p>

                <p class="target-title mb-1"> <span
                    :class="{'text-danger': listPreGoal[item]?.customer_2A < listPreGoal[item]?.target_customer_2A , 'text-success': listPreGoal[item]?.customer_2A >= listPreGoal[item]?.target_customer_2A}">
                    {{ listPreGoal[item]?.customer_2A | formatVNDNoPrefix}}</span>
                    /
                    <span>{{ listPreGoal[item]?.target_customer_2A | formatVNDNoPrefix}} </span> <small>KH có lịch hẹn</small>
                </p>

                <p class="target-title mb-1"> <span
                    :class="{'text-danger': listPreGoal[item]?.schedule_number < listPreGoal[item]?.target_schedule_number , 'text-success': listPreGoal[item]?.schedule_number >= listPreGoal[item]?.target_schedule_number}">
                    {{ listPreGoal[item]?.schedule_number | formatVNDNoPrefix }}</span>
                    /
                    <span>{{ listPreGoal[item]?.target_schedule_number | formatVNDNoPrefix}}</span> <small>Lịch Tư vấn</small>
                </p>

                <p class="target-title mb-1"> <span
                    :class="{'text-danger': listPreGoal[item]?.contract_new < listPreGoal[item]?.target_contract_new , 'text-success': listPreGoal[item]?.contract_new >= listPreGoal[item]?.target_contract_new}">
                    {{ listPreGoal[item]?.contract_new | formatVNDNoPrefix}}</span> / <span>{{ listPreGoal[item]?.target_contract_new | formatVNDNoPrefix}} </span> <small>Hợp đồng mới</small>
                </p>

                <p class="target-title mb-1 " ><span
                    :class="{'text-danger': listPreGoal[item]?.goal_amount < listPreGoal[item]?.target_amount , 'text-success': listPreGoal[item]?.goal_amount >= listPreGoal[item]?.target_amount}">
                    {{ listPreGoal[item]?.goal_amount | formatVNDNoPrefix }}</span>
                    /
                    <span>{{ listPreGoal[item]?.target_amount | formatVNDNoPrefix }}</span>
                    <small>Doanh số</small>
                </p>
            </div>

        </div>
        <el-dialog :title="titleDialog" :visible.sync="dialogTarget" width="800px" >
            <dialogHandleGoal
                v-if="dialogTarget"
                @close="dialogTarget = false"
                @changeTitleDialog="changeTitleDialog"
                @updatedGoal="emitGoal"
                :is_edit="'Sửa'"
                :goal="form"

            ></dialogHandleGoal>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment-timezone";
import dialogHandleGoal from "./dialogHandleGoal.vue";
import {mapGetters} from "vuex";
import {RESTORE_GOAL_BY_SALE} from "@/core/services/store/report.module";

export default {
    name: "ResultDashboard",
    components: {
        dialogHandleGoal,
    },
    props: {
        listPreGoal: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data() {
        return {
            currentTime: new Date(),
            moment: moment,
            is_edit: false,
            dialogTarget: false,
            loadingRestore: false,
            form: {
                targetScheduleNumber: "",
                targetCustomerNew: "",
                targetAmount: "",
                goalType: 0,
                date: ''
            },
            currentWeek: '',
            titleDialog: '',
            listPreGoalDefault: ['pre_day', 'month', 'week', 'day'],
            dateByKey: {
                'pre_day': {
                    'date': this.$moment().subtract(1, 'day').format('YYYY-MM-DD'),
                    'title': 'mục tiêu hôm qua',
                    'tooltip': `Ngày ${this.$moment().subtract(1, 'day').format('YYYY-MM-DD')}`,
                    'goal_type': 0,
                },
                'day': {
                    'date': this.$moment().format('YYYY-MM-DD'),
                    'title': 'mục tiêu ngày',
                    'tooltip': `ngày ${this.$moment().format('YYYY-MM-DD')}`,
                    'goal_type': 0,
                },

                'week': {
                    'date':  '',
                    'title': 'mục tiêu tuần',
                    'tooltip': '',
                    'goal_type': 1,
                },
                'month': {
                    'date': `tháng ${this.$moment().format('MM')}`,
                    'title': 'mục tiêu tháng',
                    'tooltip': `tháng ${this.$moment().format('MM')}`,
                    'goal_type': 2,
                },
            }
        };
    },
    watch: {
        listPreGoal: {
            handler(newVal) {
                this.listPreGoalDefault = this.getSortedKeys(newVal);
            },
        },
    },

    mounted() {
        this.listPreGoalDefault = this.getSortedKeys(this.listPreGoal);
        this.getWeek();
    },

    methods: {
        getWeek() {
            const now = this.$moment();
            const fullStart = now.clone().startOf('week');
            const fullEnd   = now.clone().endOf('week');

            const monthStart = now.clone().startOf('month');
            const monthEnd   = now.clone().endOf('month');
            const displayStart = this.$moment.max(fullStart, monthStart);
            const displayEnd   = this.$moment.min(fullEnd, monthEnd);

            this.currentWeek = `${displayStart.format('DD/MM')} - ${displayEnd.format('YYYY-MM-DD')}`;

            this.$set(this.dateByKey, 'week', {
                date: this.currentWeek,
                title: 'mục tiêu tuần',
                tooltip: `từ ${fullStart.format('YYYY-MM-DD')} đến ${fullEnd.format('YYYY-MM-DD')}`,
                goal_type: 1,
            });
        },
        getSortedKeys(data) {
            const result = ['pre_day'];
            if (!data.month) result.push('month');
            if (!data.week) result.push('week');
            if (!data.day) result.push('day');

            if (data.day) result.push('day');
            if (data.week) result.push('week');
            if (data.month) result.push('month');
            return result;
        },
        handleShowDialogTarget(item, type, type_target) {
            this.form = {
                targetScheduleNumber: this.listPreGoal[type]?.target_schedule_number ?? '',
                targetCustomerNew: this.listPreGoal[type]?.target_customer_new ?? '',
                targetAmount: this.listPreGoal[type]?.target_amount ?? '',
                targetContractNew: this.listPreGoal[type]?.target_contract_new ?? '',
                targetCustomer2A: this.listPreGoal[type]?.target_customer_2A ?? '',
                goalType: type_target,
                id: this.listPreGoal[type]?.id ?? 0
            };
            this.titleDialog = `Mục tiêu ${this.dateByKey[type]?.tooltip}`
            this.dialogTarget = true;
        },

        showDialogTarget(type, type_target) {
            this.clearForm();
            this.form.goalType = type_target;
            this.titleDialog = `Mục tiêu ${this.dateByKey[type]?.tooltip}`
            this.dialogTarget = true;
        },

        clearForm() {
            this.form = {
                targetScheduleNumber: '',
                targetCustomerNew: '',
                targetAmount: '',
                targetContractNew: '',
                targetCustomer2A: '',
                id: ''
            };
        },

        changeTitleDialog(e, type) {
            const first = e?.[0];

            if (!e || first == null) {
                console.error('changeTitleDialog: empty input', e);
                return;
            }

            const s = String(first);
            if (s === 'NaN-NaN-NaN' || s.includes('NaN')) {
                if (typeof logError === 'function') logError('Invalid date detected: ' + s);
                console.error('changeTitleDialog: invalid date', s);
                return;
            }

            switch (type) {
                case 0:
                    return this.titleDialog = `Mục tiêu ngày ${e}`;
                case 1:
                    return this.titleDialog = `Mục tiêu từ ${e[0]} đến ${e[1]}`;
                case 2:
                    const raw = Array.isArray(e) ? String(e[0]) : String(e || '');
                    const match = raw.match(/-(\d{1,2})$/) || raw.match(/(\d{1,2})$/);
                    const month = match ? String(Number(match[1])) : raw;
                    return this.titleDialog = `Mục tiêu tháng ${month}`;
                default:
                    return '';
            }
        },

        emitGoal() {
            this.$emit("reload", true);
        },

        synchronizeGoal(item, type_goal) {
          this.loadingRestore = true;
          const userId = this.currentUser.id ?? 0;
          if(!userId) {
            this.$message({type: 'error', message: `Không tìm thấy mã nhân sự`, showClose: true});
          }
          const payload = {
            userId,
            idGoal: item.id,
            type: type_goal
          }
          this.$store.dispatch(RESTORE_GOAL_BY_SALE, payload).then((res) => {
            if (res) {
              this.$notify({
                title: 'Success',
                message: res.message ?? 'Thành công',
                type: 'success'
              });
              this.emitGoal();
              this.loadingRestore = false;

            }
          });
        }
    },
    computed: {
      ...mapGetters(["currentUser", 'keyAccount']),
    },
};
</script>

<style>
#dashboard-leader .text-sale {
    font-size: 16px;
    font-weight: 600;
}
.text-warning {
    color: rgba(227, 28, 68, 0.87);
}

.expected-report-dashboard .card, .result-dashboard .card{
    height: auto !important;
}
</style>
